// Uma linha da biblioteca de componentes: arrasta para o preview ou clica
// para adicionar.
import React from "react";
import { useDrag } from "react-dnd";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";

export const ItemDaBiblioteca: React.FC<{
  componentType: any;
  onAddComponent: (type: string) => void;
}> = ({ componentType, onAddComponent }) => {
  const [{ isDragging }, drag] = useDrag({
    type: "NEW_COMPONENT",
    item: { type: "NEW_COMPONENT", componentType: componentType.id },
    end: (item, monitor) => {
      if (!monitor.didDrop()) {
        return;
      }
      onAddComponent(componentType.id);
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <AlfredoStyles.DraggableComponentItem
      ref={drag}
      isDragging={isDragging}
      onClick={() => onAddComponent(componentType.id)}
    >
      <AlfredoStyles.ComponentIcon>
        <span className="material-icons">{componentType.icon}</span>
      </AlfredoStyles.ComponentIcon>
      <AlfredoStyles.ComponentInfo>
        <AlfredoStyles.ComponentName>
          {componentType.name}
        </AlfredoStyles.ComponentName>
        <AlfredoStyles.ComponentDescription>
          {componentType.description || `Adicionar ${componentType.name}`}
        </AlfredoStyles.ComponentDescription>
      </AlfredoStyles.ComponentInfo>
      <AlfredoStyles.DragHandle>
        <span className="material-icons">open_with</span>
      </AlfredoStyles.DragHandle>
    </AlfredoStyles.DraggableComponentItem>
  );
};
